import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
    filterBeforeCreate: (toast, toasts) => {
        const filteredToasts = toasts.filter((t) => t.content === toast.content)

        return filteredToasts.length ? false : toast
    },
    maxToasts: 1,
    newestOnTop: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    timeout: 5000,
    transition: 'Vue-Toastification__bounce',
})
